import React from "react";
import { loginRequest } from "../authConfig";
import { Form, Button } from 'react-bootstrap';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";


function LogInbtn() {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginPopup(loginRequest)
            .catch((error) => console.log(error))
    }

    return (<>
        <AuthenticatedTemplate>
            <Form className="d-flex">
                <Button variant="outline-danger" onClick={() => instance.logoutPopup({ postLogoutRedirectUri: "/", mainWindowRedirectUri: "/" })} >Cerrar Sesión</Button>
            </Form>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <Form className="d-flex">
                <Button variant="success" onClick={handleLogin} >Iniciar Sesión</Button>
            </Form>
        </UnauthenticatedTemplate>
    </>)
}

export default LogInbtn;